define('extension',[],function() {

    // Avoid 'console' errors in browsers that lack a console.
    (function () {
        var method;
        var noop = function () { };
        var methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
            'timeStamp', 'trace', 'warn'
        ];
        var length = methods.length;
        var console = (window.console = window.console || {});

        while (length--) {
            method = methods[length];

            // Only stub undefined methods.
            if (!console[method]) {
                console[method] = noop;
            }
        }
    }());

    if (!Array.prototype.shuffle) {
        Array.prototype.shuffle = function() {
            var m = this.length, t, i;

            while (m) {
                i = Math.floor(Math.random() * m--);
                t = this[m];
                this[m] = this[i];
                this[i] = t;
            }
            return this;
        };
    }

    if (!Array.prototype.equals) {
        Array.prototype.equals = function (array) {

            if (!array) {
                return false;
            }

            if (this.length !== array.length) {
                return false;
            }

            for (var i = 0, l=this.length; i < l; i++) {
                if (this[i] instanceof Array && array[i] instanceof Array) {
                    if (!this[i].equals(array[i])) {
                        return false;
                    }
                }
                else if (this[i] !== array[i]) {
                    return false;
                }
            }

            return true;
        };
    }

    window.requestAnimFrame = (function(){
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function( callback ){
                window.setTimeout(callback, 1000 / 60);
            };
    })();
});

